/** 官網 — 服務條款頁 */
export const ClauseService = {
  badge: '服務條款',
  pageTitle: '課堂派服務條款',
  pageSubtitle: '請仔細閱讀以下服務條款，您的使用即表示接受本協議',
  footerTitle: '如有任何疑問',
  footerDesc: '如您對本服務條款有任何問題或建議，請隨時聯絡我們的客服團隊',
  footerContact: '聯絡我們',

  s0_title: '合約定義',
  s0_i0:
    '本網站（本合約中一律指ketangpai.com）由北京愛課互動科技有限公司（以下簡稱「愛課互動公司」）所有和運作。',
  s0_i1:
    '本合約是網站使用者（包括個人、企業及其他組織）與網站營運企業愛課互動公司之間的法律契約。使用者存取、瀏覽和註冊本網站即代表接受本合約條款的約束，使用者對本網站的存取和使用應以接受並遵守本合約所載明的條款和條件為前提。',

  s1_title: '智慧財產權聲明',
  s1_i0:
    '本網站包括但不限於應用程式、原始碼、商標、標示圖案(LOGO)、介面設計、應用程式程式設計介面(API)等所關聯的所有智慧財產權均屬愛課互動公司所有。使用者不得複製、修改、傳播或在非本網站所屬的伺服器上做鏡像或者以其它方式進行非法使用。',
  s1_i1:
    '使用者在本網站平台所建立的獨創性資料歸屬該使用者所有，該使用者有權對前述資料進行任何形式的處置，包括從平台中複製、匯出和刪除。',
  s1_i2:
    '使用者應當確保其公開或儲存（方式包括但不限於：上傳、儲存、公布、發布等）於本網站及相關伺服器的內容不存在任何侵犯其他第三方智慧財產權的情形。若存在本條所述情形，愛課互動公司有權根據具體情節針對上述內容，採取包括但不限於限制、遮蔽、刪除、修改等手段，由此給網站使用者造成的損失由網站使用者自行承擔；若愛課互動公司因網站使用者存在本條所述行為而向其他第三方承擔法律責任的，愛課互動公司有權向網站使用者追償全部損失。',

  s2_title: '網站使用規則',
  s2_i0_text: '不得上載、展示、張貼、傳播或以其它方式傳送含有下列內容之一的資訊：',
  s2_i0_sub0: '反對憲法所確定的基本原則的；',
  s2_i0_sub1: '危害國家安全，洩露國家秘密，顛覆國家政權，破壞國家統一的；',
  s2_i0_sub2: '損害國家榮譽和利益的；',
  s2_i0_sub3: '煽動民族仇恨、民族歧視、破壞民族團結的；',
  s2_i0_sub4: '破壞國家宗教政策，宣揚邪教和封建迷信的；',
  s2_i0_sub5: '散布謠言，擾亂社會秩序，破壞社會穩定的；',
  s2_i0_sub6: '散布淫穢、色情、賭博、暴力、凶殺、恐怖或者教唆犯罪的；',
  s2_i0_sub7: '侮辱或者誹謗他人，侵害他人合法權利的；',
  s2_i0_sub8:
    '含有虛假、有害、脅迫、侵害他人隱私、騷擾、侵害、中傷、粗俗、猥褻、或其它道德上令人反感的內容；',
  s2_i0_sub9: '含有中國法律、法規、規章、條例以及任何具有法律效力之規範所限制或禁止的其它內容的。',
  s2_i1: '不得為任何非法目的而使用網路服務系統；',
  s2_i2_text: '不利用課堂派服務從事以下活動：',
  s2_i2_sub0: '未經允許，進入電腦資訊網路或者使用電腦資訊網路資源的；',
  s2_i2_sub1: '未經允許，對電腦資訊網路功能進行刪除、修改或者增加的；',
  s2_i2_sub2:
    '未經允許，對進入電腦資訊網路中儲存、處理或者傳輸的資料和應用程式進行刪除、修改或者增加的；',
  s2_i2_sub3: '故意製作、傳播電腦病毒等破壞性程式的；',
  s2_i2_sub4: '其他危害電腦資訊網路安全的行為。',

  s3_title: '使用者資訊保護',
  s3_i0:
    '本網站將盡可能採取一切措施保護使用者資料及個人資料安全，只根據使用者在網站上的行為指示來分發使用者的資訊，不會向任何第三方公開或共享使用者的具體資料。',
  s3_i1:
    '本網站保留使用匯總統計性資訊的權利，在不透露單個使用者隱私資料的前提下，本網站有權對整個使用者資料庫進行分析並對使用者資料庫進行商業上的利用。',

  s4_title: '資料儲存與清理規則',
  s4_i0:
    '鑒於本平台長期為廣大使用者提供免費服務，隨著使用者規模持續增長，歷史資料儲存壓力日益增大。為保障全體使用者的系統使用流暢性與資料讀取效率，本平台將在不影響正常教學功能的前提下，有權對課堂作業資料進行不定期歸檔或刪除。<strong>清理範圍僅限於學生作業附件</strong>，作業題目、提交時間、教師評語、作業成績等核心教學資料將完整保留。',
  s4_i1_text: '具體清理規則如下：',
  s4_i1_sub0:
    '<strong>長期未登入使用者：</strong>連續1年（365天）未登入本平台的使用者，其課堂內相關學生作業附件將不再保留，包括但不限於文件、圖片、音視訊、壓縮檔案等各類附件資料；',
  s4_i1_sub1:
    '<strong>正常活躍使用者：</strong>近12個月內有登入記錄的教師使用者，自作業開啟時間起，平台預設保留12個月（365天）的學生作業附件。請各位教師使用者及時下載並妥善儲存所需的作業附件資料。',
  s4_i1_sub2:
    '<strong>帳號凍結與資料清理：</strong>對於連續1年（365天）未登入本平台的使用者，平台有權對該帳號進行凍結，並依照本條款對帳號關聯資料進行清理（包括但不限於作業附件、冗餘快取資料等）；核心教學記錄（作業題目、提交時間、教師評語、成績等）按既有規則保留。',
  s4_i2: '本平台建議使用者定期備份重要資料，以確保教學資料的長期儲存與使用。',

  s5_title: '免責聲明',
  s5_i0:
    '本網站將盡最大努力保障軟體平台的連續可靠運行，但鑒於網路服務的特殊性，本網站對可能發生的網路服務的中斷或終止所可能導致的一切損失，不承擔任何法律責任及經濟賠償。',
  s5_i1:
    '本網站將盡最大努力保障客戶資料的安全備份，但無法承諾100%的資料恢復，對因資料遺失帶來的任何直接或間接損失不承擔任何責任。',
  s5_i2:
    '在發生需要從備份檔案中恢復資料的情形時，本網站通常需要4小時，最長48小時完成，在此時間範圍內的資料恢復視作服務是連續的。',
  s5_i3:
    '對於因不可抗力或本網站不能控制的原因造成的網路服務中斷和長時間終止，本網站不承擔任何責任，但將盡力減少因此而給使用者造成的損失和影響。',

  s6_title: '合約變更',
  s6_i0: '本網站有權隨時對本合約的條款進行修訂，一旦本合約的內容發生變更，本網站將會在修訂生效日前一個工作日更新。',
  s6_i1: '如使用者繼續使用網路服務，則視為使用者接受本網站對合約相關條款所做的修訂。',

  s7_title: '其他',
  s7_i0: '本協議的訂立、執行和解釋及爭議的解決均應適用中華人民共和國法律。',
  s7_i1:
    '如雙方就本協議內容或其執行發生任何爭議，雙方應盡量友好協商解決；協商不成時，任何一方均可向課堂派所在地的人民法院提起訴訟。',
}
